import { render, staticRenderFns } from "./Lgx02652061151464840495342.vue?vue&type=template&id=32906796&"
import script from "./Lgx02652061151464840495342.vue?vue&type=script&lang=js&"
export * from "./Lgx02652061151464840495342.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports